module.exports = __webpack_public_path__ + "img/001234567896.0c8f65e3.png";